import PropTypes from 'prop-types';

export const giftedAudiobookProps = {
  gifteeEmail: PropTypes.string,
  gifteeName: PropTypes.string,
  fromName: PropTypes.string,
  deliveryDate: PropTypes.string,
  displayDeliveryDate: PropTypes.string,
  message: PropTypes.string,
};

export const giftedAudiobook = PropTypes.shape(giftedAudiobookProps);
